import { User } from '@site-mate/dashpivot-shared-library';

export enum TeamPermissions {
  Controller = 'Team Controller',
  Member = 'Team Member',
}
export enum ProjectPermissions {
  Controller = 'Project Controller',
}

export enum OrganisationPermissions {
  Controller = 'Org Controller',
}

export type UserPermissions = TeamPermissions | ProjectPermissions | OrganisationPermissions;

export interface UserWeb extends User {
  isActivated?: boolean;
  emailStatus?: {
    status: number | string;
    sentAt: string;
  };
  activationResendCount?: number;
  permission?: UserPermissions;
}
